'use client';

import { SessionProvider } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';
import { SyncProvider } from '@/components/providers/SyncProvider';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const pathname = usePathname();
  if (pathname?.startsWith('/word-addin')) {
    return <>{children}</>;
  }
  return (
    <SessionProvider>
      {/* Server-side persistenca: localStorage ⇄ baza sinhronizacija ob prijavi (seja 219, A4) */}
      <SyncProvider />
      {children}
    </SessionProvider>
  );
}
